// @flow

import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";

import List from "./List";
import { RelativeBox as StyledSearch } from "src/styles/box";

type Props = {
  focus: number,
  text: string,
  createNew: boolean,
  settings: Object,
  result: Array<number>,
  outerRef: any,
  handleClose: Function,
  setFocus: Function,
  handleSelect: Function,
  handleInvite: Function,
  startConversation: Function
};

type State = {
  focus: number
};

class Result extends Component<Props, State> {
  search: Object;

  state = {
    focus: 0
  };

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleClickOutside = e => {
    const { outerRef, handleClose } = this.props;
    if (outerRef) {
      if (!outerRef.contains(e.target)) {
        handleClose();
      }
    }
  };

  handleKeyDown = (event: any) => {
    // Close Search when esc is pressed
    if (event.keyCode === 27) {
      const { handleClose } = this.props;
      handleClose();
    }

    if (event.keyCode === 38) {
      const { setFocus } = this.props;
      setFocus("up");
      event.preventDefault();
    }

    if (event.keyCode === 40) {
      const { setFocus } = this.props;
      setFocus("down");
      event.preventDefault();
    }
  };

  render() {
    const {
      text,
      focus,
      settings,
      createNew,
      result,
      outerRef,
      handleSelect,
      handleInvite,
      startConversation
    } = this.props;
    return (
      <StyledSearch
        onKeyDown={this.handleKeyDown}
        role="button"
        tabIndex="0"
        ref={this.search}
      >
        <List
          text={text}
          focus={focus}
          result={result}
          outerRef={outerRef}
          handleSelect={handleSelect}
          handleInvite={handleInvite}
          createNew={createNew}
          startConversation={startConversation}
          settings={settings}
        />
      </StyledSearch>
    );
  }
}

export default onClickOutside(Result);
